import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import "./index.scss";

export const OrderReceipt = ({ totals }) => {
  const money = (value) => toMoneyWithTwoDecimalDigits(value);
  return (
    <div className="order-receipt" data-testid="order-receipt">
      <div className="totals">
        <div className="sub-totals">
          <p>
            Subtotal: <span>{money(totals.item_total)}</span>
          </p>
          <p>
            Tax: <span>{money(totals.tax_total)}</span>
          </p>
          {!!totals.ship_total && (
            <p>
              Shipping: <span>{money(totals.ship_total)}</span>
            </p>
          )}
          {!!totals.promo_code && (
            <p>
              Promo Code: <span>-{money(Math.abs(totals.promo_code))}</span>
            </p>
          )}
          {!!totals.raise_cash && (
            <p>
              GCX Cash: <span>-{money(Math.abs(totals.raise_cash))}</span>
            </p>
          )}
        </div>
        <div className="total">
          Total: <span>{money(totals.total)}</span>
        </div>
        <div className="savings">
          Your savings: <span>{money(totals.savings_total)}</span>
        </div>
      </div>
    </div>
  );
};
